<template>
    <div class="experiment-wrapper">
      <div class="parametr">
        <!-- Панель управления -->
        <div class="controls">
          <div>
            <label>Масса мяча (кг):</label>
            <input type="number" v-model="ballMass" min="0.1" step="0.1" />
          </div>
          <div>
            <label>Гравитация (м/с²):</label>
            <input type="number" v-model="gravity" min="0.1" step="0.1" />
          </div>
          <div>
            <label>Высота падения (м):</label>
            <input type="number" v-model="dropHeight" min="0.1" step="0.1" />
          </div>
  
          <!-- Выбор материала мяча -->
          <div>
            <label>Выберите материал мяча:</label>
            <select v-model="ballMaterial">
              <option value="rubber">Резина</option>
              <option value="wood">Дерево</option>
              <option value="metal">Металл</option>
            </select>
          </div>
          <!-- Настройка параметров мяча -->
          <div>
            <label>Плотность материала мяча:</label>
            <input type="number" v-model="ballDensity" min="0.1" step="0.1" />
          </div>
          <div>
            <label>Коэффициент трения мяча:</label>
            <input type="number" v-model="ballFriction" min="0.0" max="1.0" step="0.05" />
          </div>
          <div>
            <label>Коэффициент отскока мяча:</label>
            <input type="number" v-model="ballRestitution" min="0.0" max="1.0" step="0.05" />
          </div>
  
          <!-- Выбор материала пола -->
          <div>
            <label>Выберите материал пола:</label>
            <select v-model="groundMaterial">
              <option value="wood">Дерево</option>
              <option value="concrete">Бетон</option>
              <option value="metal">Металл</option>
            </select>
          </div>
          <!-- Настройка параметров пола -->
          <div>
            <label>Плотность материала пола:</label>
            <input type="number" v-model="groundDensity" min="0.1" step="0.1" />
          </div>
          <div>
            <label>Коэффициент трения пола:</label>
            <input type="number" v-model="groundFriction" min="0.0" max="1.0" step="0.05" />
          </div>
          <div>
            <label>Коэффициент отскока пола:</label>
            <input type="number" v-model="groundRestitution" min="0.0" max="1.0" step="0.05" />
          </div>
  
  
          <button @click="resetExperiment">Запустить</button>
        </div>
  
        <!-- Отображение параметров -->
        <div class="parameters">
          <p><strong>Скорость (X):</strong> {{ speedX.toFixed(2) }}</p>
          <p><strong>Скорость (Y):</strong> {{ speedY.toFixed(2) }}</p>
          <p><strong>Масса мяча:</strong> {{ ballMass }} кг</p>
          <p><strong>Положение (X):</strong> {{ positionX.toFixed(2) }}</p>
          <p><strong>Положение (Y):</strong> {{ positionY.toFixed(2) }}</p>
          <p><strong>Гравитация:</strong> {{ gravity }} м/с²</p>
          <p><strong>Высота падения:</strong> {{ dropHeight }} м</p>
        </div>
      </div>
  
      <!-- Канвас для отображения эксперимента -->
      <div class="canvas-container">
        <canvas ref="worldCanvas"></canvas>
      </div>
    </div>
  </template>
  
  <script>
  import Matter from 'matter-js';
  
  export default {
    name: 'NewtonExperiment',
    data() {
      return {
        engine: null,
        world: null,
        render: null,
        ball: null,
        ground: null,
        runner: null,
        speedX: 0,
        speedY: 0,
        positionX: 0,
        positionY: 0,
        ballMass: 1,
        gravity: 9.81,
        dropHeight: 200,
        ballMaterial: 'rubber',
        groundMaterial: 'wood',
        ballDensity: 1.0, // Плотность мяча
        ballFriction: 0.3, // Коэффициент трения мяча
        ballRestitution: 0.7, // Коэффициент отскока мяча
        groundDensity: 1.0, // Плотность пола
        groundFriction: 0.5, // Коэффициент трения пола
        groundRestitution: 0.3, // Коэффициент отскока пола
      };
    },
    methods: {
      initPhysics() {
        const { Engine, Render, World, Runner } = Matter;
  
        this.engine = Engine.create();
        this.world = this.engine.world;
  
        this.engine.world.gravity.y = this.gravity;
  
        const canvas = this.$refs.worldCanvas;
        this.render = Render.create({
          canvas: canvas,
          engine: this.engine,
          options: {
            width: 800,
            height: 600,
            wireframes: false,
          }
        });
  
        this.ground = this.createGround();
        this.ball = this.createBall();
  
        World.add(this.world, [this.ground, this.ball]);
  
        this.runner = Runner.create();
  
        Render.run(this.render);
        Runner.run(this.runner, this.engine);
      },
  
      updateParameters() {
        const ballVelocity = this.ball.velocity;
        const position = this.ball.position;
  
        this.speedX = ballVelocity.x;
        this.speedY = ballVelocity.y;
        this.positionX = position.x;
        this.positionY = position.y;
      },
  
      createGround() {
        const { Bodies } = Matter;
        let groundOptions = {
          friction: this.groundFriction,
          restitution: this.groundRestitution,
          density: this.groundDensity,
        };
  
        switch (this.groundMaterial) {
          case 'wood':
            groundOptions.friction = 0.5;
            break;
          case 'concrete':
            groundOptions.friction = 0.8;
            break;
          case 'metal':
            groundOptions.friction = 0.2;
            break;
        }
  
        return Bodies.rectangle(400, 580, 800, 40, { isStatic: true, ...groundOptions });
      },
  
      createBall() {
        const { Bodies } = Matter;
        let ballOptions = {
          restitution: this.ballRestitution,
          friction: this.ballFriction,
          density: this.ballDensity,
        };
  
        switch (this.ballMaterial) {
          case 'rubber':
            ballOptions.friction = 0.3;
            break;
          case 'wood':
            ballOptions.friction = 0.5;
            break;
          case 'metal':
            ballOptions.friction = 0.1;
            break;
        }
  
        return Bodies.circle(400, this.dropHeight, 40, ballOptions);
      },
  
      resetExperiment() {
        if (this.ball) {
          Matter.Body.setPosition(this.ball, { x: 400, y: this.dropHeight });
          Matter.Body.setVelocity(this.ball, { x: 0, y: 0 });
        }
      },
  
      startExperiment() {
        if (this.ball) {
          console.log('Запуск эксперимента');
          const force = { x: 0, y: -0.05 };
          Matter.Body.applyForce(this.ball, this.ball.position, force);
        }
      },
  
      updateParamsLoop() {
        this.updateParameters();
        requestAnimationFrame(this.updateParamsLoop);
      }
    },
  
    mounted() {
      this.initPhysics();
      requestAnimationFrame(this.updateParamsLoop);
    },
  
    beforeUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  };
  </script>
  
  <style scoped>
  .experiment-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px;
    position: relative;
  }
  
  .parametr {
    display: flex;
    flex-direction: column;
  }
  
  .controls {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 15px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 5px;
    width: 300px;
    z-index: 10;
  }
  
  .controls input,
  .controls select {
    margin-bottom: 10px;
  }
  
  button {
    margin-top: 10px;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
  }
  
  .parameters {
    margin-top: 20px;
    padding: 10px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    width: 300px;
    border-radius: 5px;
  }
  
  .parameters p {
    margin: 5px 0;
  }
  
  .canvas-container {
    margin-left: 20px;
    flex-grow: 1;
  }
  </style>
  